const SERVER_ERROR_CODES = {
    SESSION_EXPIRED: 401,
    ACCOUNT_LOCKED: 423,
    TOO_MANY_REQUEST: 429,
    SYSTEM_MAINTAIN: 503,
    INACTIVE_PROMOCODE: 410,
}

export default SERVER_ERROR_CODES;